/**
 * Panel "Koszty z KSeF" dla AccountingPage (zakladka koszty-ksef): dwie podzakladki -
 * "Do zaksięgowania" (ZKsefTab) i "Podsumowanie miesięczne" (PodsumowanieMiesieczneTab).
 * Te same komponenty ExternalCostsPage pokazuje jako osobne zakladki.
 */
import React, { useState } from 'react';
import ZKsefTab from './ZKsefTab';
import PodsumowanieMiesieczneTab from './PodsumowanieMiesieczneTab';

const przelacznik = (aktywny) => ({
  padding: '6px 12px', fontSize: '12px', fontWeight: 600, borderRadius: '4px', cursor: 'pointer',
  border: `1px solid ${aktywny ? 'var(--primary)' : 'var(--border)'}`,
  background: aktywny ? 'var(--primary)' : 'var(--card-bg)', color: aktywny ? '#fff' : 'var(--text-secondary)',
});

export default function KosztyKsefPanel({ sklepy = [], locationId = '', onZaksiegowano }) {
  const [widok, setWidok] = useState('z-ksef');
  const [ile, setIle] = useState(null);
  return (
    <div>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '10px' }}>
        <button type="button" data-testid="panel-z-ksef" onClick={() => setWidok('z-ksef')} style={przelacznik(widok === 'z-ksef')}>
          Do zaksięgowania{ile !== null ? ` (${ile})` : ''}
        </button>
        <button type="button" data-testid="panel-miesiecznie" onClick={() => setWidok('miesiecznie')} style={przelacznik(widok === 'miesiecznie')}>
          Podsumowanie miesięczne
        </button>
      </div>
      {widok === 'z-ksef' && <ZKsefTab sklepy={sklepy.length ? sklepy : undefined} locationId={locationId} onZaksiegowano={onZaksiegowano} onLiczba={setIle} />}
      {widok === 'miesiecznie' && <PodsumowanieMiesieczneTab sklepy={sklepy} locationId={locationId} />}
    </div>
  );
}
